import * as React from "react";
import { IDefaultViewProps } from "./IDefaultViewProps";
import { Caption } from "../../atoms/views/Caption";
import { OpmerkingenIcon } from "../../atoms/icons/OpmerkingenIcon";

// All the incoming values
interface IProps {
}

// Outgoing functions
interface IDispatch {
}

// Actual Component
export type AllProps = IProps & IDispatch & IDefaultViewProps<string | null>;
export const Opmerkingen = (props: AllProps) => {
    return (<Caption {...props} caption={props.label || "Opmerkingen"} icon={<OpmerkingenIcon />}>
        {props.value}
    </Caption>)
}

